import BadgeManager from './badge_manager';

export default BadgeManager;
